export default function BotaoTuit(){
    return (
        <a>
            <button className="btn-primary">TUITAR</button>
        </a>
    )
}